import type { SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { gpsDevicesEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	CreateGpsDeviceRequest,
	GpsDevice,
	GpsDeviceListParams,
	GpsDevicePaginatedResponse,
	UpdateGpsDeviceRequest,
} from "../types";

export const gpsDevicesService = {
	async list(params: GpsDeviceListParams): Promise<GpsDevicePaginatedResponse> {
		const response = await apiClient.get<GpsDevicePaginatedResponse>(gpsDevicesEndpoints.list, {
			params,
		});
		return response.data;
	},

	async getById(id: string): Promise<GpsDevice> {
		const url = replaceParams(gpsDevicesEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<GpsDevice>>(url);
		return response.data.data;
	},

	async create(data: CreateGpsDeviceRequest): Promise<GpsDevice> {
		const response = await apiClient.post<SuccessResponse<GpsDevice>>(
			gpsDevicesEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdateGpsDeviceRequest): Promise<GpsDevice> {
		const url = replaceParams(gpsDevicesEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<GpsDevice>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(gpsDevicesEndpoints.delete, { id });
		await apiClient.delete(url);
	},
};
